import fp from 'lodash/fp';
import { routerReducer } from 'react-router-redux';
import { persistCombineReducers } from 'redux-persist';
import createFilter from 'redux-persist-transform-filter';
import storage from 'redux-persist/lib/storage';
import * as modules from './modules';

const reducers = fp.flow(
  fp.map((key) => [key, fp.get(key, modules).reducer]),
  fp.filter(fp.identity)
)(fp.keys(modules));

const rootReducer = persistCombineReducers({
  key: 'primary',
  storage: storage,
  whitelist: ['session'],
  transforms: [
    createFilter('session', ['idToken'])
  ]
}, {
    ...fp.fromPairs(reducers),
    router: routerReducer
  });

export default rootReducer;



// WEBPACK FOOTER //
// ./src/state/reducers.js